import { Controller } from "@hotwired/stimulus"

/**
 * Ui::Calendar::DayTimelineComponent companion controller: the timeline's one
 * event. Clicking a chip, or pressing Enter on it, dispatches a bubbling
 * `ui--calendar--day-timeline:select` with `{ id, kind }` — kind "stop" or
 * "booking". Nothing else is handled: no drag, no resize, no create.
 *
 *   <div data-action="ui--calendar--day-timeline:select->host#selectStop">
 */
export default class extends Controller {
  connect() {
    this._onClick = (event) => this._select(event)
    this._onKeydown = (event) => {
      if (event.key !== "Enter") return
      // The chip is a button: without this, Enter would also click it and
      // the select would fire twice.
      if (this._select(event)) event.preventDefault()
    }
    this.element.addEventListener("click", this._onClick)
    this.element.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    this.element.removeEventListener("click", this._onClick)
    this.element.removeEventListener("keydown", this._onKeydown)
  }

  _select(event) {
    const chip = event.target.closest("[data-timeline-entry-kind]")
    if (!chip || !this.element.contains(chip)) return false

    this.dispatch("select", {
      detail: {
        id: chip.getAttribute("data-timeline-entry-id"),
        kind: chip.getAttribute("data-timeline-entry-kind"),
      },
    })
    return true
  }
}
